import { createAsyncThunk } from '@reduxjs/toolkit';

import { ThunkExtra } from 'application/store';

import { EVALUATE_FLAGS_QUERY, FlagEvaluationGql } from '@shared/api/configFlags/configFlagsApi';

export const fetchConfigFlags = createAsyncThunk('configFlags/fetch', async (_, { extra }) => {
  const { configFlagsApolloClient } = extra as ThunkExtra;

  const { data } = await configFlagsApolloClient.query<{ evaluateFlags: FlagEvaluationGql[] }>({
    query: EVALUATE_FLAGS_QUERY,
    fetchPolicy: 'network-only',
  });

  const evaluations = data?.evaluateFlags ?? [];

  return Object.fromEntries(evaluations.map(({ flagName, value }) => [flagName, value]));
});
